/**
 * Input validation utilities for room IDs and usernames.
 * These validators match the server-side validation to ensure consistency.
 */

/**
 * Validate a room ID according to server rules.
 * @param {string} roomId - The room ID to validate
 * @returns {{valid: boolean|null, message: string}} Validation result
 */
export const validateRoomId = (roomId) => {
  if (!roomId) return { valid: null, message: '' };
  if (roomId.length < 1 || roomId.length > 64) {
    return { valid: false, message: 'Room ID must be 1-64 characters' };
  }
  if (!/^[a-zA-Z0-9_-]+$/.test(roomId)) {
    return { valid: false, message: 'Only letters, numbers, - and _ allowed' };
  }
  return { valid: true, message: 'Valid room ID' };
};

/**
 * Validate a username according to server rules.
 * @param {string} username - The username to validate
 * @returns {{valid: boolean|null, message: string}} Validation result
 */
export const validateUsername = (username) => {
  if (!username) return { valid: null, message: '' };
  if (username.length < 1 || username.length > 32) {
    return { valid: false, message: 'Username must be 1-32 characters' };
  }
  if (/[<>]/.test(username)) {
    return { valid: false, message: 'Cannot contain < or >' };
  }
  return { valid: true, message: 'Valid username' };
};
